import {
  NodeUtils,
  createBlock,
  mergeBlock,
  t,
} from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  SectionWidgetElement,
  ElementDefinition,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BlockRenderer } from "@easy-email-pro-core/components";
import { cloneDeep } from "lodash";

const defaultData: ElementDefinition<SectionWidgetElement>["defaultData"] = {
  attributes: {},
  data: {
    description: "",
    config: [],
    input: {},
  },
};

export const SectionWidget = createBlock<SectionWidgetElement>({
  get name() {
    return t("Widget");
  },
  void: true,
  defaultData,
  type: BasicType.SECTION_WIDGET,
  create: (payload) => {
    const data: SectionWidgetElement = {
      type: BasicType.SECTION_WIDGET,
      title: "MY FIRST WIDGET",
      data: {
        ...defaultData.data,
      },
      attributes: {},
      children: [{ text: "" }],
    };
    return mergeBlock(data, payload);
  },
  get category() {
    return ElementCategory.SECTION;
  },
  render(params) {
    const { node } = params;
    const blockData = cloneDeep(node.children[0]);

    if (!NodeUtils.isElement(blockData)) return null;

    return <BlockRenderer {...params} node={blockData} />;
  },
});
